/**
 * The Culinary Journeys of Chef Eddie & Kiki G.
 *
 * Dates and destinations transcribed directly from Chef Eddie's handwritten
 * travel calendar. Entries marked "tbc" (to be confirmed) intentionally have no
 * invented detail — they display cleanly and can be edited later.
 *
 * 2026–27 Season · October 2026 → March 2027
 */
export const journeyTimeline = [
  {
    slug: "fremont",
    dateShort: "10.05",
    dateLabel: "OCT 05",
    fullDate: "October 5, 2026",
    monthLabel: "October · 2026",
    season: "Autumn 2026",
    destination: "Fremont",
    status: "confirmed",
  },
  {
    slug: "kikis-birthday",
    dateShort: "10.06",
    dateLabel: "OCT 06",
    fullDate: "October 6, 2026",
    monthLabel: "October · 2026",
    season: "Autumn 2026",
    destination: "Kiki's B-Day",
    note: "A celebration",
    status: "confirmed",
  },
  {
    slug: "mk",
    dateShort: "10.13",
    dateLabel: "OCT 13",
    fullDate: "October 13, 2026",
    monthLabel: "October · 2026",
    season: "Autumn 2026",
    destination: "MK",
    status: "tbc",
  },
  {
    slug: "philly",
    dateShort: "10.15",
    dateLabel: "OCT 15",
    fullDate: "October 15, 2026",
    monthLabel: "October · 2026",
    season: "Autumn 2026",
    destination: "Philly",
    status: "confirmed",
  },
  {
    slug: "sunday-funday-october",
    dateShort: "10.18",
    dateLabel: "OCT 18",
    fullDate: "October 18, 2026",
    monthLabel: "October · 2026",
    season: "Autumn 2026",
    destination: "Sunday Funday",
    status: "tbc",
  },
  {
    slug: "new-england-nova-scotia",
    dateShort: "10.19",
    dateLabel: "OCT 19",
    fullDate: "October 19, 2026",
    monthLabel: "October · 2026",
    season: "Autumn 2026",
    destination: "New England / Nova Scotia",
    region: "Atlantic Coast",
    status: "confirmed",
    image:
      "https://readdy.ai/api/search-image?query=Rugged%20New%20England%20and%20Nova%20Scotia%20coastline%20in%20autumn%20with%20a%20weathered%20lighthouse%2C%20rocky%20shore%20and%20cold%20Atlantic%20mist%2C%20cinematic%20editorial%20travel%20photography%2C%20muted%20warm%20earthy%20palette%2C%2035mm%20film%20grain%2C%20soft%20haze&width=1600&height=900&seq=timeline-newengland&orientation=landscape",
  },
  {
    slug: "oct-20-to-confirm",
    dateShort: "10.20",
    dateLabel: "OCT 20",
    fullDate: "October 20, 2026",
    monthLabel: "October · 2026",
    season: "Autumn 2026",
    destination: "To Be Confirmed",
    status: "tbc",
  },
  {
    slug: "montauk",
    dateShort: "10.31",
    dateLabel: "OCT 31",
    fullDate: "October 31, 2026",
    monthLabel: "October · 2026",
    season: "Autumn 2026",
    destination: "Montauk",
    status: "confirmed",
    image:
      "https://readdy.ai/api/search-image?query=Montauk%20coastal%20dunes%20and%20long%20grass%20at%20dusk%20with%20an%20empty%20beach%20and%20distant%20surf%2C%20cinematic%20editorial%20travel%20photography%2C%20muted%20warm%20earthy%20palette%2C%2035mm%20film%20grain%2C%20soft%20haze&width=1600&height=900&seq=timeline-montauk&orientation=landscape",
  },
  {
    slug: "sunday-funday-november",
    dateShort: "11.01",
    dateLabel: "NOV 01",
    fullDate: "November 1, 2026",
    monthLabel: "November · 2026",
    season: "Autumn 2026",
    destination: "Sunday Funday",
    status: "tbc",
  },
  {
    slug: "rent-a-car-return",
    dateShort: "11.02",
    dateLabel: "NOV 02",
    fullDate: "November 2, 2026",
    monthLabel: "November · 2026",
    season: "Autumn 2026",
    destination: "Rent a Car / Return",
    note: "A travel day",
    status: "confirmed",
  },
  {
    slug: "las-vegas",
    dateShort: "11.05",
    dateLabel: "NOV 05",
    fullDate: "November 5, 2026",
    monthLabel: "November · 2026",
    season: "Autumn 2026",
    destination: "Las Vegas",
    region: "Nevada",
    status: "confirmed",
    image:
      "https://readdy.ai/api/search-image?query=Las%20Vegas%20boulevard%20at%20night%20with%20warm%20neon%20glow%20and%20desert%20haze%2C%20cinematic%20editorial%20travel%20photography%2C%20moody%20warm%20amber%20palette%2C%2035mm%20film%20grain%2C%20atmospheric&width=1600&height=900&seq=timeline-vegas&orientation=landscape",
  },
  {
    slug: "puerto-rico",
    dateShort: "11.24",
    dateLabel: "NOV 24",
    fullDate: "November 24, 2026",
    monthLabel: "November · 2026",
    season: "Autumn 2026",
    destination: "Puerto Rico",
    region: "Caribbean",
    status: "confirmed",
    image:
      "https://readdy.ai/api/search-image?query=Old%20San%20Juan%20Puerto%20Rico%20street%20with%20pastel%20colonial%20walls%20and%20hanging%20plants%20in%20warm%20afternoon%20light%2C%20cinematic%20editorial%20travel%20photography%2C%20muted%20warm%20palette%2C%2035mm%20film%20grain&width=1600&height=900&seq=timeline-puertorico&orientation=landscape",
  },
  {
    slug: "new-york",
    dateShort: "11.26",
    dateLabel: "NOV 26",
    fullDate: "November 26, 2026",
    monthLabel: "November · 2026",
    season: "Autumn 2026",
    destination: "New York",
    region: "New York",
    status: "confirmed",
  },
  {
    slug: "prague-november",
    dateShort: "11.27",
    dateLabel: "NOV 27",
    fullDate: "November 27, 2026",
    monthLabel: "November · 2026",
    season: "Autumn 2026",
    destination: "Prague",
    note: "With Koko",
    status: "confirmed",
    image:
      "https://readdy.ai/api/search-image?query=Prague%20old%20town%20at%20dawn%20in%20winter%20mist%20with%20a%20stone%20bridge%20and%20spires%2C%20cinematic%20editorial%20travel%20photography%2C%20muted%20warm%20palette%2C%2035mm%20film%20grain%2C%20soft%20haze&width=1600&height=900&seq=timeline-prague-nov&orientation=landscape",
  },
  {
    slug: "charleston",
    dateShort: "12.05",
    dateLabel: "DEC 05",
    fullDate: "December 5, 2026",
    monthLabel: "December · 2026",
    season: "Winter 2026–27",
    destination: "Charleston",
    region: "South Carolina",
    status: "confirmed",
  },
  {
    slug: "belize",
    dateShort: "12.20",
    dateLabel: "DEC 20",
    fullDate: "December 20, 2026",
    monthLabel: "December · 2026",
    season: "Winter 2026–27",
    destination: "Belize",
    region: "Central America",
    status: "confirmed",
    image:
      "https://readdy.ai/api/search-image?query=Belize%20turquoise%20caribbean%20water%20meeting%20a%20lush%20green%20shoreline%20with%20palm%20shade%2C%20cinematic%20editorial%20travel%20photography%2C%20warm%20natural%20palette%2C%2035mm%20film%20grain&width=1600&height=900&seq=timeline-belize&orientation=landscape",
  },
  {
    slug: "paris",
    dateShort: "12.25",
    dateLabel: "DEC 25",
    fullDate: "December 25, 2026",
    monthLabel: "December · 2026",
    season: "Winter 2026–27",
    destination: "Paris",
    status: "confirmed",
    image:
      "https://readdy.ai/api/search-image?query=Parisian%20street%20corner%20at%20dusk%20in%20winter%20with%20warm%20cafe%20light%20and%20wet%20cobblestones%2C%20cinematic%20editorial%20travel%20photography%2C%20muted%20warm%20palette%2C%2035mm%20film%20grain%2C%20soft%20haze&width=1600&height=900&seq=timeline-paris&orientation=landscape",
  },
  {
    slug: "prague-january",
    dateShort: "01.16",
    dateLabel: "JAN 16",
    fullDate: "January 16, 2027",
    monthLabel: "January · 2027",
    season: "Winter 2026–27",
    destination: "Prague",
    status: "confirmed",
  },
  {
    slug: "san-diego",
    dateShort: "01.24",
    dateLabel: "JAN 24",
    fullDate: "January 24, 2027",
    monthLabel: "January · 2027",
    season: "Winter 2026–27",
    destination: "San Diego",
    status: "tbc",
  },
  {
    slug: "super-bowl-la",
    dateShort: "02.13",
    dateLabel: "FEB 13",
    fullDate: "February 13, 2027",
    monthLabel: "February · 2027",
    season: "Winter 2026–27",
    destination: "Los Angeles",
    note: "Super Bowl",
    status: "confirmed",
  },
  {
    slug: "vietnam",
    dateShort: "02.16",
    dateLabel: "FEB 16",
    fullDate: "February 16, 2027",
    monthLabel: "February · 2027",
    season: "Winter 2026–27",
    destination: "Vietnam",
    status: "confirmed",
    image:
      "https://readdy.ai/api/search-image?query=Vietnamese%20street%20food%20alley%20at%20night%20lit%20by%20paper%20lanterns%20with%20steam%20and%20warm%20glow%2C%20cinematic%20editorial%20travel%20photography%2C%20muted%20warm%20amber%20palette%2C%2035mm%20film%20grain&width=1600&height=900&seq=timeline-vietnam&orientation=landscape",
  },
  {
    slug: "africa",
    dateShort: "03.10",
    dateLabel: "MAR 10",
    fullDate: "March 10, 2027",
    monthLabel: "March · 2027",
    season: "Spring 2027",
    destination: "Africa",
    status: "confirmed",
    image:
      "https://readdy.ai/api/search-image?query=African%20savanna%20at%20golden%20hour%20with%20acacia%20trees%20and%20long%20grass%20under%20a%20vast%20warm%20sky%2C%20cinematic%20editorial%20travel%20photography%2C%20muted%20warm%20earthy%20palette%2C%2035mm%20film%20grain%2C%20soft%20haze&width=1600&height=900&seq=timeline-africa&orientation=landscape",
  },
  {
    slug: "grand-cayman",
    dateShort: "03.17",
    dateLabel: "MAR 17",
    fullDate: "March 17, 2027",
    monthLabel: "March · 2027",
    season: "Spring 2027",
    destination: "Grand Cayman",
    region: "Caribbean",
    status: "confirmed",
    image:
      "https://readdy.ai/api/search-image?query=Grand%20Cayman%20turquoise%20caribbean%20sea%20meeting%20white%20sand%20with%20palm%20shade%2C%20cinematic%20editorial%20travel%20photography%2C%20warm%20natural%20palette%2C%2035mm%20film%20grain&width=1600&height=900&seq=timeline-cayman&orientation=landscape",
  },
];